import SingleCard from '../components/UI/SingleCard';

export const CARD_IMAGES = [
  { src: '/images/deck/2-clubs.svg', value: 2 },
  { src: '/images/deck/2-hearts.svg', value: 2 },
  { src: '/images/deck/2-spades.svg', value: 2 },
  { src: '/images/deck/2-diamonds.svg', value: 2 },
  { src: '/images/deck/3-clubs.svg', value: 3 },
  { src: '/images/deck/3-hearts.svg', value: 3 },
  { src: '/images/deck/3-spades.svg', value: 3 },
  { src: '/images/deck/3-diamonds.svg', value: 3 },
  { src: '/images/deck/4-clubs.svg', value: 4 },
  { src: '/images/deck/4-hearts.svg', value: 4 },
  { src: '/images/deck/4-spades.svg', value: 4 },
  { src: '/images/deck/4-diamonds.svg', value: 4 },
  { src: '/images/deck/5-clubs.svg', value: 5 },
  { src: '/images/deck/5-hearts.svg', value: 5 },
  { src: '/images/deck/5-spades.svg', value: 5 },
  { src: '/images/deck/5-diamonds.svg', value: 5 },
  { src: '/images/deck/6-clubs.svg', value: 6 },
  { src: '/images/deck/6-hearts.svg', value: 6 },
  { src: '/images/deck/6-spades.svg', value: 6 },
  { src: '/images/deck/6-diamonds.svg', value: 6 },
  { src: '/images/deck/7-clubs.svg', value: 7 },
  { src: '/images/deck/7-hearts.svg', value: 7 },
  { src: '/images/deck/7-spades.svg', value: 7 },
  { src: '/images/deck/7-diamonds.svg', value: 7 },
  { src: '/images/deck/8-clubs.svg', value: 8 },
  { src: '/images/deck/8-hearts.svg', value: 8 },
  { src: '/images/deck/8-spades.svg', value: 8 },
  { src: '/images/deck/8-diamonds.svg', value: 8 },
  { src: '/images/deck/9-clubs.svg', value: 9 },
  { src: '/images/deck/9-hearts.svg', value: 9 },
  { src: '/images/deck/9-spades.svg', value: 9 },
  { src: '/images/deck/9-diamonds.svg', value: 9 },
  { src: '/images/deck/10-clubs.svg', value: 10 },
  { src: '/images/deck/10-hearts.svg', value: 10 },
  { src: '/images/deck/10-spades.svg', value: 10 },
  { src: '/images/deck/10-diamonds.svg', value: 10 },
  { src: '/images/deck/ace-clubs.svg', value: 1 },
  { src: '/images/deck/ace-hearts.svg', value: 1 },
  { src: '/images/deck/ace-spades.svg', value: 1 },
  { src: '/images/deck/ace-diamonds.svg', value: 1 },
  { src: '/images/deck/jack-clubs.svg', value: 0 },
  { src: '/images/deck/jack-hearts.svg', value: 0 },
  { src: '/images/deck/jack-spades.svg', value: 0 },
  { src: '/images/deck/jack-diamonds.svg', value: 0 },
  { src: '/images/deck/king-clubs.svg', value: 0 },
  { src: '/images/deck/king-hearts.svg', value: 0 },
  { src: '/images/deck/king-spades.svg', value: 0 },
  { src: '/images/deck/king-diamonds.svg', value: 0 },
  { src: '/images/deck/queen-clubs.svg', value: 0 },
  { src: '/images/deck/queen-hearts.svg', value: 0 },
  { src: '/images/deck/queen-spades.svg', value: 0 },
  { src: '/images/deck/queen-diamonds.svg', value: 0 },
];

export const INITIAL_CARD_IMAGES = [
  { src: '/images/deck/back-red.svg', value: 0, class: 'flip' },
  { src: '/images/deck/back-black.svg', value: 0, class: 'flip' },
];

export const renderCards = (cards) => {
  return cards.map((card, idx) => <SingleCard style={card.class} key={idx} image={card.src} />);
};

export const renderWinClass = (winner) => (winner ? 'game__cards--win' : '');
